import logo from '../img/logo.png'
import '../css/footer.css'

const Footer = () => {
  return (
    <div className='footerContainer'>
      <img className='logoFooter' src={logo} alt='lbdesign'/>
      <h4>© 2026 Lbdesignweb.com</h4>
    </div>
  )
}

export default Footer